const ConfirmExitModal = ({
    isOpen,
    onConfirm,
    onCancel,
    title = 'Do you want to save your changes?',
    message = '',
    confirmText = 'Save',
    cancelText = 'No'
}) => {
    if (!isOpen) return null;

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center'>
            {/* Backdrop */}
            <div
                className='absolute inset-0 bg-black bg-opacity-50'
                onClick={onCancel}
            />

            {/* Modal Container */}
            <div className='relative bg-white rounded-[30px] p-8 mx-4 w-full max-w-md border-[6px] border-[#52FF00] shadow-lg min-h-[200px]'>
                {/* Close Button */}
                <button
                    onClick={onCancel}
                    className='absolute top-1 right-2 text-gray-600 hover:text-gray-800 transition-colors bg-[#EDEDED] rounded-full p-4 w-[22px] h-[22px] flex items-center justify-center '
                >
                    x
                </button>

                {/* Content */}
                <div className='text-center'>
                    {/* Title */}
                    <h2 className='text-[22px] font-poppins text-black mb-6 leading-tight'>
                        {title}
                    </h2>

                    {/* Message */}
                    {message && (
                        <p className='text-gray-600 mb-6 text-base'>
                            {message}
                        </p>
                    )}

                    {/* Buttons */}
                    <div className='flex gap-4'>
                        {/* Save Button */}
                        <button
                            onClick={onConfirm}
                            className='w-full py-4 bg-black text-white rounded-full text-[22px] font-semibold hover:bg-gray-800 transition-colors'
                        >
                            {confirmText}
                        </button>

                        {/* No Button */}
                        <button
                            onClick={onCancel}
                            className='w-full py-4 bg-transparent text-[#A5A5A5] border-2 border-[#A5A5A5] text-[22px] font-semibold hover:border-gray-400 transition-colors rounded-full'
                        >
                            {cancelText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmExitModal;
